export default __webpack_public_path__ + "static/media/logo_words.d2f3e891.png";